export default __webpack_public_path__ + "static/media/photo--lg--namrata-1.90778f8d.jpg";